import React from 'react';
import {getFormatDistance} from './utils';

const ShopItem = ({item}) =>
    <li
        className="list-group-item list-group-item-action flex-column align-items-start"
        data-idshop={item.shop.id}
        data-shopbrand={item.shop?.brand?.permalink}
    >
        <a href={item.href}
           data-idshop={item.shop.id} className="gtm_store-item">
            <div className="d-flex w-100 justify-content-between">
                <div className="mb-1 list-group-title">{item.name}
                    <span className="iconPartner isInlineBlock"/></div>
            </div>

            <p className="mb-1">
                {!!item.street_number && <>{`${item.street_number}, `}</>}
                {!!item.route && <>{`${item.route}`},<br/></>}
                {item.postal_code} {item.town}
            </p>

            {!!item.phone && <small className="text-muted">{`${item.phone}`}</small>}

            <div className="isFloatRight shop_link">
                <small>{getFormatDistance (item)}</small>
                <i className="fa fa-arrow-right" aria-hidden="true"/>
            </div>

        </a>
    </li>

export default ShopItem;